import { useState, useCallback } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import LoginScreen from "@/components/LoginScreen";
import Inbox from "@/components/Inbox";

const STORAGE_KEY = "claude_access_session";

function loadSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function App() {
  const [session, setSession] = useState(loadSession);

  const handleSuccess = useCallback((data) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    setSession(data);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setSession(null);
  }, []);

  return (
    <div className="App">
      {session ? (
        <Inbox session={session} onLogout={handleLogout} />
      ) : (
        <LoginScreen onSuccess={handleSuccess} />
      )}
      <Toaster
        position="top-center"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E7E5E4",
            color: "#141413",
            fontFamily: "Figtree, sans-serif",
            borderRadius: "12px",
            boxShadow: "0 8px 30px rgba(20,20,19,0.10)",
          },
        }}
      />
    </div>
  );
}

export default App;
